import React from "react";
import { SSO_LANDING } from "../../constants/resources";
import { COOKIE } from "../../../../shared/js/constants";

const { flex } = window;

const SSOLanding = () => {

    const handleContinueClick = () => {
        flex.setCookie({
            key: COOKIE.FLEX_SSOLANDING_VISITED,
            value: 'true',
            expireMinutes: 365 * 24 * 60,
            options: {
                secure: true,
                sameSite: 'Lax'
            }
        });

        flex.redirect('/sso');
    };

    return (
        <div className="interstitial-wrapper">
            <div className="interstitial-body">
                <div className="interstitial-header">
                    <div className="wordmark" />
                </div>
                <div className="interstitial-main-content">
                    <div className="interstitial-content">
                        <p className="interstitial-content__header">
                            {SSO_LANDING.CONTENT_HDR}
                        </p>
                        <p className="interstitial-content__desc">
                            {SSO_LANDING.CONTENT_TXT}
                        </p>
                        <div className="interstitial-content__actions">
                            <button className="continue-btn" onClick={handleContinueClick}>
                                <span className="continue-btn__label">{SSO_LANDING.ACT_CONTINUE}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SSOLanding;